import { BASE_THEME } from '@cibo/ui'
import { Button, createTheme, ThemeProvider } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Google from './GoogleIcon'

const GOOGLE_THEME = createTheme({
  palette: {
    primary: {
      main: '#FFF',
    },
  },
  ...BASE_THEME,
})

export default (props: { onPress(): void }) => {
  const { t } = useTranslation('auth0')

  return (
    <ThemeProvider theme={GOOGLE_THEME}>
      <Button
        data-testid="auth0_google_button"
        onClick={props.onPress}
        size="large"
        startIcon={<Google size={16} />}
        variant="contained"
      >
        {t('googleButton')}
      </Button>
    </ThemeProvider>
  )
}
